import React, { Component } from 'react';
import { Provider } from 'react-redux';
import Routes from '../routes';
import {BrowserRouter} from 'react-router-dom';

class Root extends Component {

  render() {
    return (
      <div>
        <Provider store={this.props.store}>
          <BrowserRouter>
            <Routes />
          </BrowserRouter>
        </Provider>
      </div>
    );
  }
}

export default Root;


// WEBPACK FOOTER //
// ./src/root/Root.prod.js